import { render, staticRenderFns } from "./PcCryptoDonation.vue?vue&type=template&id=47dac6bd&scoped=true&"
import script from "./PcCryptoDonation.vue?vue&type=script&lang=js&"
export * from "./PcCryptoDonation.vue?vue&type=script&lang=js&"
import style0 from "./PcCryptoDonation.vue?vue&type=style&index=0&id=47dac6bd&prod&scoped=true&lang=css&"
import style1 from "./PcCryptoDonation.vue?vue&type=style&index=1&id=47dac6bd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dac6bd",
  null
  
)

export default component.exports